import { HTTP } from '@/http-common';
import { Dealer } from '../../../models/Dealer';

import { getField, updateField } from 'vuex-map-fields';
import { createHelpers } from 'vuex-map-fields';
import { httpError } from '@/models/httpError';

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `dealer/getField`,
  mutationType: `dealer/updateField`,
});

export const { mapMultiRowFields: mapDealerMultiRowFields } = createHelpers({
  getterType: 'dealer/getField',
  mutationType: 'dealer/updateField',
});

const state = () => ({
  dealer: new Dealer(),
  dealers: [],
  message: new httpError(),
});

const actions = {
  resetDealer({ commit }) {
    commit('setDealer', new Dealer());
    commit('addDealers', [new Dealer()]);
  },
  refreshDealer({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get('oms/UpdateDealersFromOMS/')
        .then(() => {
          dispatch('listDealers');
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in getting dealers : ' + err.message,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },
  getDealer({ commit, dispatch }) {
    var response = HTTP.get('Order/getDealer/' + state.dealerID);
    response
      .then(function (data) {
        var resultData = data.data;
        commit('setDealer', resultData);
      })
      .catch((err) => {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Error in getting dealers : ' + err.message,
            httpStatus: 500,
          })
        );
      });
  },
  addDealer({ state, commit }) {
    commit('setDealer', state.dealer);
  },
  editDealerManager({ dispatch }, dealerManager) {
    return new Promise(async (resolve, reject) => {
      try {
        var result = await HTTP.post(
          'order/EditDealerManager/' + dealerManager.dealerID,
          dealerManager
        );
        if (result.status == 200) {
          dispatch(
            'setMessage',
            new httpError({ message: 'Dealer Edited', httpStatus: 200 })
          );
          resolve();
        }
      } catch (error) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Dealer Not Edited' + error.message,
            httpStatus: 500,
          })
        );
        reject();
      }
    });
  },
  async removeDealer({ commit, dispatch }, dealerID) {
    if (dealerID == null || typeof dealerID == 'undefined') {
      return new Promise.reject();
    }
    try {
      var result = await HTTP.delete('order/DeleteDealer/' + dealerID);
      if (result.status == 200) {
        commit('removeRow', dealerID);
        dispatch(
          'setMessage',
          new httpError({ message: 'Dealer removed', httpStatus: 200 })
        );
      }
    } catch (error) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Dealer not removed: ' + error.message,
          httpStatus: 500,
        })
      );
    }
  },
  listDealers({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('order/listDealers');
      response
        .then((data) => {
          if (data.status !== 200) resolve();
          var result = data.data;
          commit('addDealers', result);
          dispatch(
            'setMessage',
            new httpError({ message: 'Dealers retrieved', httpStatus: 200 })
          );
          resolve(result);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error getting dealers' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listDealersManagement() {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post('DealerPortal/ListDealersDetail');
        if (response.status !== 200) resolve(response);
        var result = response.data;
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  getDealerAuth({ dispatch }, dealer) {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await HTTP.get('order/getDealerAuth/' + dealer.dealerID);
        dispatch(
          'setMessage',
          new httpError({ message: 'Retreived OK', httpStatus: 200 })
        );
        resolve(response.data);
      } catch (err) {
        reject(err);
      }
    });
  },
  getDealerManager({ dispatch }, dealerIndex) {
    return new Promise((resolve, reject) => {
      let response = HTTP.get('order/getDealerManager/' + dealerIndex);
      response
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Retreived OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch((err) => reject(err));
    });
  },
  updateDealerAuth({ dispatch }, auth) {
    return new Promise((resolve, reject) => {
      HTTP.post('dealerPortal/updateDealerAuth/', auth)
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateDealerManager({ dispatch }, dealerManager) {
    return new Promise((resolve, reject) => {
      let response = HTTP.post(
        'dealerPortal/updateDealerManager/0',
        dealerManager
      );
      response
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  deleteDealerAuth({ dispatch }, authID) {
    return new Promise((resolve, reject) => {
      HTTP.delete('dealerPortal/deleteDealerAuth/' + authID)
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  saveDealer({ dispatch }, dealer) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('order/updateDealer/' + dealer.dealerID, dealer);
      response
        .then((data) => {
          var result = data.data;
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(result);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateAuth({ dispatch }, auth) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('order/updateAuth', auth);
      response
        .then((data) => {
          if (data.status == 200)
            dispatch(
              'setMessage',
              new httpError({
                message: 'Auth changed',
                httpStatus: 200,
              })
            );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Auth not saved:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  resetPassword({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/resetAuth0Password', {
        email: email,
      })
        .then(function (data) {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Reset email submitted',
                httpStatus: 200,
              })
            );
            resolve(state.message);
          } else {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Email missing!',
                httpStatus: 500,
              })
            );
            resolve(state.message);
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Reset email Not sent:' + err.message,
              httpStatus: 500,
            })
          );
          reject(state.message);
        });
    });
  },
  async getAuth({ dispatch, commit }, email) {
    return new Promise(async (resolve, reject) => {
      if (typeof email == 'undefined') {
        resolve();
        return;
      }

      try {
        var response = await HTTP.post('Order/getDealerFromEmail', {
          email: email,
        });
        var resultData = response.data;

        //commit("setDealer", response.data);
        resolve(resultData);
      } catch (error) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'unable to retrieve auth level',
            httpStatus: 500,
          })
        );
        reject(error);
      }
    });
  },
  searchAuth0({ state, dispatch }, email) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/searchAuth0User', {
        email: email,
      })
        .then((data) => {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'SOG email validated',
                httpStatus: 200,
              })
            );
            resolve(state.message);
          } else {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Email missing!',
                httpStatus: 500,
              })
            );
            resolve(state.message);
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(state.message);
        });
    });
  },

  createAuth({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('DealerPortal/createAuthUser', {
        email: email,
      });
      response
        .then((data) => {
          if (data.status == 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'SOG email created',
                httpStatus: 200,
              })
            );
          } else
            dispatch(
              'setMessage',
              new httpError({
                message: 'Email missing!',
                httpStatus: 500,
              })
            );
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              // message: "Error: " + err.message,
              message: 'The user already exists.',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },

  getContract({ dispatch }, dealerID) {
    return new Promise(async (reject) => {
      try {
        var response = await HTTP.get(
          'DealerPortal/DownloadDealerContract/' + dealerID,
          { responseType: 'blob' }
        );
      } catch (err) {
        dispatch(
          'setMessage',
          new httpError({ message: err.message, httpStatus: 500 })
        );
        reject(err);
      }
      {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.type })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'contract_' + dealerID + '.pdf');
        document.body.appendChild(link);
        link.click();
      }
    });
  },
  listMissingDealers() {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post('DealerPortal/MissingDealers');
        if (response.status !== 200) resolve(response);
        var result = response.data;
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

const mutations = {
  setDealer(state, dealer) {
    state.dealer = dealer;
  },
  setProgress(state, message) {
    state.message = message;
  },
  addDealers(state, dealers) {
    state.dealers = dealers;
  },
  addRow(state) {
    let dealer = new Dealer();
    state.dealers.push(dealer);
    return state.dealers.indexOf(dealer);
  },
  removeRow(state, dealerID) {
    let dealer = state.dealers.filter((x) => x.dealerID == dealerID);
    let index = state.dealers.indexOf(dealer[0]);
    if (index > 0) state.dealers.splice(index, 1);
  },
  updateField,
};
const getters = {
  dealer: (state) => {
    return state.dealer;
  },
  hasDealer: (state) => state.dealer.dealerID > 0,
  getField,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
